import React, {useEffect, useState} from "react";
import { useAppDispatch, useAppSelector } from "app/store/hook";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserMenuModel } from "app/model/ua/user-menu";
import { setCurrentMenu } from "app/reducers/menuSlice";
import Account from "app/components/layout/comp/Account";
import MegaMenu from "./MegaMenu";
import EneruseLogo from "./comp/EneruseLogo";

export default function Header() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentUrl = location.pathname;
  const { menus, flatMenus, rootMenu, currentMenu }: any = useAppSelector(state => state.menus);
  const [showTopMenu, setShowTopMenu] = useState<boolean>(true);
  const [activeMenu, setActiveMenu] = useState<UserMenuModel>();
  const [fullMenuOpen, setFullMenuOpen] = useState<boolean>(false);

  // 전체메뉴가 열려 있는 동안 뒤 화면 스크롤을 막는다 (layout.css 의 .fullOpen)
  useEffect(() => {
    const wrap = document.getElementById('wrap');
    document.documentElement.classList.toggle('fullOpen', fullMenuOpen);
    wrap?.classList.toggle('fullOpen', fullMenuOpen);
    if (!fullMenuOpen) return;

    const handleResize = () => setFullMenuOpen(false);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      document.documentElement.classList.remove('fullOpen');
      wrap?.classList.remove('fullOpen');
    };
  }, [fullMenuOpen]);

  useEffect(() => {
    setShowTopMenu(!currentUrl.includes('/sign-up/'));
  }, [currentUrl]);

  useEffect(() => {
    if (rootMenu) {
      setActiveMenu(rootMenu);
    } else {
      const matched = flatMenus.find((menu: UserMenuModel) =>
        menu.menuUrlAddr && currentUrl.startsWith(menu.menuUrlAddr));
      if (matched) {
        let tempArray: UserMenuModel[] = [];
        let currentMenuDepth = matched.depth ?? 0;
        if (currentMenuDepth > 1) {
          tempArray.push(matched);
          for (let i = 0; i < currentMenuDepth - 1; i++) {
            const upperMenuId = tempArray[0].uppoMenuId;
            if (upperMenuId) {
              const upperMenu = flatMenus.find((menu: UserMenuModel) => menu.menuId === upperMenuId);
              if (upperMenu) {
                tempArray.unshift(upperMenu);
              }
            }
          }
          dispatch(setCurrentMenu({currentMenu: matched, rootMenu: tempArray[0]}));
          setActiveMenu(tempArray[0]);
        } else {
          dispatch(setCurrentMenu({currentMenu: matched, rootMenu: matched}));
          setActiveMenu(matched);
        }
      }
    }
  }, [flatMenus, currentUrl, rootMenu]);

  function handleClickMenu(item: UserMenuModel, rootMenuItem: UserMenuModel) {
    setActiveMenu(rootMenuItem);
    const hasUrl: boolean = !!item.menuUrlAddr && item.menuUrlAddr !== "";
    const hasChildren: boolean = (item.subMenus?.length ?? 0) > 0;

    if (hasUrl) {
      dispatch(setCurrentMenu({ currentMenu: item, rootMenu: rootMenuItem }));
      navigate(item.menuUrlAddr!);
      setFullMenuOpen(false);
    } else if (!hasChildren) {
      dispatch(setCurrentMenu({ currentMenu: item, rootMenu: rootMenuItem }));
    }
  }

  // 홈("/" → 역할별 대시보드)으로 갈 때 이전 메뉴 선택을 지워, 주소 기준으로 활성 메뉴를 다시 잡게 한다
  function handleClickLogo() {
    dispatch(setCurrentMenu({ currentMenu: undefined, rootMenu: undefined }));
    setActiveMenu(undefined);
    setFullMenuOpen(false);
  }

  return (
    <>
      <div id="header">
        <div className="header-wrap">
          <h1 className="logo">
            <Link to="/" title="홈 화면으로 이동" onClick={handleClickLogo}>
              <EneruseLogo />
              <span className="hid">ENERUSE</span>
            </Link>
          </h1>

          <MegaMenu
            visible={showTopMenu}
            menus={menus}
            activeMenu={activeMenu}
            currentMenu={currentMenu}
            onClick={handleClickMenu}
          />

          <a
            href="#fullMenu"
            className="fullmenuBtn"
            id="fullmenuOpen"
            onClick={(e) => {
              e.preventDefault();
              setFullMenuOpen((open) => !open);
            }}
          >
            <em><em></em></em>
            <span className="hid">메뉴 열기</span>
          </a>

          <div className="util">
            <Account />
          </div>
        </div>
      </div>

      <div className={fullMenuOpen ? 'popFullmenu is-open' : 'popFullmenu'}>
        <div id="fullMenu">
          <h3 className="hid">전체메뉴</h3>
          <div className="fullMenu-container">
            <div className="container">
              <div className="nav">
                <MegaMenu
                  visible
                  variant="full"
                  menus={menus}
                  activeMenu={activeMenu}
                  currentMenu={currentMenu}
                  onClick={handleClickMenu}
                />
              </div>
            </div>
          </div>
          <a
            href="#fullmenuOpen"
            id="fullmenuClose"
            className="fullmenuBtn"
            onClick={(e) => {
              e.preventDefault();
              setFullMenuOpen(false);
            }}
          >
            <span className="hid">전체메뉴 닫기</span>
            <i className="xi-close"></i>
          </a>
        </div>
      </div>
    </>
  );
}
